import { useEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { useTableHeaderPositionContext } from '~/components/v2/components/shared/table/TableHeaderPositionContextProvider';

export const useHeaderResize = () => {
  const { ref, height } = useResizeDetector({ handleWidth: false });
  const { setTableHeaderTopPosition } = useTableHeaderPositionContext();

  useEffect(() => {
    setTableHeaderTopPosition(height ?? 0);
  }, [height, setTableHeaderTopPosition]);

  return ref;
};
